import React from "react";
import { useNavigate } from "react-router-dom";
import { FaCalendarAlt } from "react-icons/fa";

const EventHero = () => {
  const navigate = useNavigate();

  const scrollToPackages = () => {
    const packageSection = document.getElementById("packages");
    if (packageSection) {
      packageSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleBookParty = () => {
    navigate("/party-request");
  };

  return (
    <div className="relative w-full py-8 sm:py-10 px-4 sm:px-6 md:px-8 bg-[#050733] flex flex-col items-center justify-center text-center select-none border-b border-white/10">
      <div className="relative z-10 max-w-5xl mx-auto flex flex-col items-center w-full">
        {/* Main Headline with Strikes & Shots brand colors */}
        <h1 className="font-heading font-bold text-white text-xl sm:text-2xl md:text-3xl lg:text-[32px] leading-snug tracking-wide uppercase max-w-4xl mx-auto">
          One Ultimate Sports Experience.{" "}
          <span className="text-primaryBtnHoverColor">Three Packages</span>{" "}
          To Match Your Group Size.
        </h1>

        {/* Subhead */}
        <p className="text-gray-300 font-subheading text-xs sm:text-sm md:text-base max-w-2xl mx-auto mt-2.5 sm:mt-3 leading-relaxed">
          Birthdays, team celebrations, family gatherings, social events, and
          get-togethers.
        </p>

        {/* Action Buttons styled with Strikes & Shots website theme */}
        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 mt-5 sm:mt-6">
          <button
            onClick={scrollToPackages}
            className="bg-transparent hover:bg-white hover:text-primaryBtnColor text-white font-subheading font-semibold text-xs sm:text-sm px-5 sm:px-6 py-2.5 rounded-md border-2 border-white transition-all duration-200 shadow-md active:scale-95 tracking-wider uppercase cursor-pointer"
          >
            <span>View Packages</span>
          </button>

          <button
            onClick={handleBookParty}
            className="bg-primaryBtnHoverColor hover:bg-red-800 text-white font-subheading font-bold text-xs sm:text-sm px-5 sm:px-6 py-2.5 rounded-md shadow-lg shadow-red-950/40 transition-all duration-200 hover:scale-[1.02] active:scale-95 flex items-center gap-2 tracking-wider uppercase cursor-pointer"
          >
            <FaCalendarAlt className="text-xs" />
            <span>Book / Request A Party</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventHero;
